import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const Nova = definePreset(Lara, {
    semantic: {
        primary: {
            50: '#f0f7f6',
            100: '#d9ece9',
            200: '#b3d5cf',
            300: '#8cbeb4',
            400: '#409181',
            500: '#006c5b', // Cummins Green / Deep Teal
            600: '#005548', // Hover state
            700: '#004238',
            800: '#003028',
            900: '#001e19',
            950: '#000f0c'
        },
        formField: {
            borderRadius: '4px'
        }
    },
    components: {
        datatable: {
            // Replicates the clean background and padding layouts from your HTML sample
            header: {
                background: '#f4f4f4',
                color: '#212529',
                borderColor: '#d6d6d6',
                padding: '0.75rem 1rem'
            },
            headerCell: {
                background: '#f4f4f4',
                color: '#212529',
                borderColor: '#e0e0e0',
                padding: '0.5rem 0.75rem'
            },
            columnTitle: {
                // Moved from headerCell.fontWeight: @primeuix/themes v20 token schema
                // relocates header font weight to datatable.column.title.font.weight
                fontWeight: '700'
            },
            bodyCell: {
                borderColor: '#e0e0e0',
                padding: '0.6rem 0.75rem'
            }
        }
    }
});
